import React, { Component } from 'react';
import { connect } from 'react-redux';

import AccountTypeFilter from 'components/layouts/Account/AccountTypeFilter';
import PositionsRenderer from 'components/layouts/Account/PositionsRenderer';
import {
  autoGroupColumnDef,
  defaultColumnDef,
  ColumnDefFactory,
  autoGroupColumnDefMobile
} from 'components/layouts/Account/WorkplaceColumnDefs';
import { AccountNameRenderer } from 'services/TableUtils';
import { getRpsBalances } from 'state/account/AccountBalancesSelectors';
import { getWorkplaceGridAccounts } from 'state/account/WorkplaceGridSelectors';
import { isDesktopLayout } from 'state/view/ViewSelectors';
import { getAccountsGridPrintLayout } from 'state/account/AccountsGridSelectors';
import { PRINT_NONE } from 'services/PrintUtils';
import { getAsOfDate } from 'state/account/AccountSelectors';
import { getCustomerWebView } from 'state/customer/CustomerSelectors';

const WorkplaceGridDataProvider = (WrappedComponent) => {
  class WorkplaceGridData extends Component {
    // react components
    frameworkComponents = {
      accountTypeFilter: AccountTypeFilter,
      positionsRenderer: PositionsRenderer,
      accountNameRenderer: AccountNameRenderer
    };

    gridOptions = {
      detailCellRendererParams: {
        detailGridOptions: {
          groupDefaultExpanded: 0
        },
        autoHeight: true
      },
      overlayNoRowsTemplate:
        '<span>No accounts to show. Please try different filtering options.</span>',
      detailCellRenderer: 'positionsRenderer',
      domLayout: 'autoHeight',
      groupDefaultExpanded: -1,
      masterDetail: true,
      embedFullWidthRows: true,
      animateRows: true,
      applyColumnDefOrder: true,
      groupSuppressBlankHeader: true,
      suppressCellSelection: true,
      suppressAggFuncInHeader: true,
      suppressColumnVirtualization: true,
      suppressContextMenu: true
    };

    generateColumnDefs = (accounts) => {
      const columnDefFactory = new ColumnDefFactory();
      return accounts && accounts[0]
        ? Object.getOwnPropertyNames(accounts[0]).reduce(
          (arr, curr) => [
            ...arr,
            columnDefFactory.createColumnDef(curr, accounts)
          ],
          []
        )
        : [];
    };

    render() {
      const {
        autoGroupColumnDef,
        isDesktopLayout,
        workplaceAccounts,
        isPrintLayout,
        asOfDate,
        isCustomerWebView
      } = this.props;

      const data = {
        columnDefs: this.generateColumnDefs(workplaceAccounts),
        defaultColumnDef,
        autoGroupColumnDef,
        components: this.components,
        frameworkComponents: this.frameworkComponents,
        gridOptions: this.gridOptions,
        asOfDate: asOfDate
      };

      return (
        <WrappedComponent
          workplaceAccounts={workplaceAccounts}
          isDesktopLayout={isDesktopLayout}
          isPrintLayout={isPrintLayout}
          {...data}
          isCustomerWebView={isCustomerWebView}
        />
      );
    }
  }

  const mapStateToProps = (state) => {
    const desktopLayout = isDesktopLayout(state);
    const printLayout = getAccountsGridPrintLayout(state);
    const isPrintLayout = printLayout !== PRINT_NONE;

    return {
      workplaceAccounts: getWorkplaceGridAccounts(state),
      isDesktopLayout: desktopLayout,
      rpsBalances: getRpsBalances(state),
      autoGroupColumnDef:
        !desktopLayout || isPrintLayout
          ? autoGroupColumnDefMobile
          : autoGroupColumnDef,
      isPrintLayout: isPrintLayout,
      asOfDate: getAsOfDate(state),
      isCustomerWebView: getCustomerWebView(state)
    };
  };

  return connect(mapStateToProps)(WorkplaceGridData);
};

export default WorkplaceGridDataProvider;
